export default __webpack_public_path__ + "static/media/logo.fe07c5c4.svg";